// The actual laws behind Stratia's privacy promises (#117 follow-on,
// 2026-08-17, founder direction: "cite the regulations that call it out
// with source links... the actual citation numbers"). One canonical file so
// the marketing page, Settings, and the signup consent screen never drift
// from each other or from what was actually verified.
//
// Every citation below was checked against the official register the same
// day this file was written (leginfo.legislature.ca.gov for California
// statutes, eur-lex.europa.eu for the GDPR, ftc.gov for COPPA) - not recalled
// from memory. If a citation is ever wrong, the fix is here, once.
//
// WHAT THIS IS NOT: a compliance claim. Each entry states what a specific
// law requires or defines - it does not assert Stratia is a "covered
// business" under the CCPA, a covered "operator" under SOPIPA (written for
// K-12 school-contracted services; Stratia is signed up for directly by
// families, not purchased by a school), or a service COPPA's substantive
// rules apply to (Stratia avoids that question entirely by not serving
// anyone under 13, rather than building COPPA's parental-consent
// machinery). Founder, 2026-08-17: "we are just stating a fact... not
// claiming general compliance with the whole regulation." Every `cite`
// string and every surrounding sentence at each call site must hold that
// line - the law says X; we do X; not "we comply with [law]".
//
// The EU AI Act is deliberately NOT included here. Its Annex III names AI
// systems institutions use to determine admission or evaluate learning
// outcomes as high-risk - close enough to Stratia's fit/odds tools that
// citing it without careful framing could read backwards. Needs a founder
// decision on exact wording before it's added anywhere.

const LEGINFO_CIV = (section) =>
    `https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?lawCode=CIV&sectionNum=${section}`;
const SOPIPA_URL =
    'https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?division=8.&chapter=22.2.&lawCode=BPC';
const COPPA_URL =
    'https://www.ftc.gov/legal-library/browse/rules/childrens-online-privacy-protection-rule-coppa';
const GDPR_URL =
    'https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:02016R0679-20160504';

export const REGULATION_CITATIONS = {
    neverSell: [
        { law: 'SOPIPA', cite: 'Cal. Bus. & Prof. Code 22584(b)(3)', url: SOPIPA_URL },
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.120(a)(1)', url: LEGINFO_CIV('1798.120') },
    ],
    noTargetedAds: [
        { law: 'SOPIPA', cite: 'Cal. Bus. & Prof. Code 22584(b)(1)', url: SOPIPA_URL },
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.121(a)', url: LEGINFO_CIV('1798.121') },
    ],
    neverForTraining: [
        { law: 'SOPIPA', cite: 'Cal. Bus. & Prof. Code 22584(b)(2)', url: SOPIPA_URL },
    ],
    pseudonymizedAnalysis: [
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.140(aa), definition of "pseudonymize"', url: LEGINFO_CIV('1798.140') },
        { law: 'GDPR', cite: 'Art. 4(5)', url: GDPR_URL },
    ],
    thirteenPlus: [
        { law: 'COPPA', cite: '15 U.S.C. 6501 et seq.; 16 C.F.R. Part 312', url: COPPA_URL },
    ],
    downloadData: [
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.100, 1798.130(a)', url: LEGINFO_CIV('1798.100') },
        { law: 'GDPR', cite: 'Art. 20', url: GDPR_URL },
    ],
    deleteAccount: [
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.105(a)', url: LEGINFO_CIV('1798.105') },
        { law: 'GDPR', cite: 'Art. 17', url: GDPR_URL },
    ],
    dataMinimization: [
        { law: 'CCPA', cite: 'Cal. Civ. Code 1798.100(c)', url: LEGINFO_CIV('1798.100') },
        { law: 'GDPR', cite: 'Art. 5(1)(c)', url: GDPR_URL },
    ],
    // No entry for the essay-coach promise ("Your words stay yours") -
    // deliberately: it is an academic-integrity commitment, not something a
    // privacy law requires. Forcing a citation onto it would be exactly the
    // overreach this file exists to avoid.
};
